import { Component,HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Plantel } from 'src/app/models/Plantel';
import { PlantelesService } from 'src/app/services/planteles.service';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-listadeplanteles',
  templateUrl: './listadeplanteles.component.html',
  styleUrls: ['./listadeplanteles.component.css']
})
export class ListadeplantelesComponent implements OnInit {

   datoss=JSON.parse(localStorage.getItem('datos')!);
  mailusu= this.datoss.correop;

  @HostBinding('class') classes = 'row';


  planteless: Plantel = {
    idplantel: 0,
    claveplantel: '',
    direccion: '',
    codigopostal: '',
    localidad: '',
    municipio: '',
    grupos: 0,
    turno: '',
    telefono: '',
    idcolegio: 0,
    esactivo: true,
    talumnos: '',
    cmni: '',
    taulas: '',
    ndirector: '',
    cor: '',
    control: '',
    coorde: '',
    mh: '',
    mm: '',
    cargodirect: '',
    maps:"",
    correoinstitucional:'',
    telefonodirector:'',
    correopers:''
  };

resetPlantel() {
  this.planteless = {
    claveplantel: '',
    nombreplantel: '',
    esactivo: true,
    direccion: '',
    localidad: '',
    municipio: '',
    colonia: '',
    codigopostal: '',
    grupos: 0,
    turno: '',
    talumnos: '',
    cmni: '',
    taulas: '',
    ndirector: '',
    cargodirect: '',
    cor: '',
    control: '',
    coorde: '',
    telefono: '',
    mh: '',
    mm: '',
    maps:'',
    correoinstitucional:'',
    telefonodirector:'',
    correopers:''
  };
}

  idplantel: any= [];
   planteles: any=[];
  urlMapa: SafeResourceUrl | null = null;

  p: number=1;
  plantel:string;
Nombre:string;
datos:any;
cargo: any;
permiso=true;
cargodirector=true;
permisosplantel=true;
permisosdg=false;


dtOptions: DataTables.Settings = {};
dtTrigger: Subject<any> = new Subject<any>();
  constructor(private plantelesService: PlantelesService,private msj:mensajeSesionExpiradaService,private router:Router, private sanitizer: DomSanitizer) { 
    this.datos=JSON.parse(localStorage.getItem('datos')!);
    this.plantel=this.datos.plantel;
    this.Nombre=this.datos.nom;
    this.cargo=this.datos.cargodb;

  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      language: {
        url: 'https://cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
      }
    };
    this.getPlanteles();
    this.permisos();
    this.permisosdirector();
  }

  getPlanteles(){
 
    this.plantelesService.getfiltrarPlantel(this.plantel).subscribe(
      res=>{

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();   
          return;
      }
      
        this.planteles=res;
        console.log(this.planteles)
        this.dtTrigger.next();

      },
      err=> console.error(err)
    )
  }
  mostrarMapaPlantel(mapsUrl: string) {
    if (!mapsUrl) {
      this.urlMapa = null;
      return;
    }

    let embedUrl: string;

    if (mapsUrl.includes('/maps/embed')) {
      embedUrl = mapsUrl; // ya es embed
    } else if (mapsUrl.includes('/maps/place/')) {
      embedUrl = mapsUrl.replace('/maps/place/', '/maps/embed/place/');
    } else {
      embedUrl = mapsUrl.replace('/maps/', '/maps/embed/');
    }

    this.urlMapa = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }


plantelinf(idplantel: any){
  this.idplantel=idplantel;
  this.getPlantelId();
  this.plantelesService.getPlantel(idplantel)
  .subscribe(
res => {

  if(res=="TOKEN-EXPIRADO"){
    this.msj.tokenExpiradoCerrarSesion();   
    return;
}

  this.planteless = res;
},
err => console.log(err)
);
}
/////////////////////////////////////////////////////////////
getPlantelId(){
  this.plantelesService.getPlantel(this.idplantel)
  .subscribe(
res => {

  if(res=="TOKEN-EXPIRADO"){
    this.msj.tokenExpiradoCerrarSesion();   
    return;
}

  this.planteless = res;
},
err => console.log(err)
); 
}


editarPlantel() {
 
  console.log(this.idplantel);
    this.plantelesService.updatePlantel(this.idplantel, this.mailusu, this.planteless).subscribe(
      res => {

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();   
          return;
      }

console.log(res)
         
      Swal.fire({
  title: '<i  style="color:#4CAF50;"></i> ¡Información Actualizada Exitosamente!',
  html: '<p style="text-align:center; color:#333; margin:10px 0;">Los datos se han modificado correctamente.</p>',
  icon: 'success',
  iconColor: '#4CAF50',
  confirmButtonText: 'Aceptar',
  confirmButtonColor: '#720f3c',
  background: '#ffffff',
  customClass: {
    popup: 'animated-popup'
  },
  backdrop: 'rgba(0,0,0,0.3)'
});
           setTimeout(function () { location.reload(); }, 1500);

      },
      err => console.error(err)
    );
  
}

eliminarPlantel(id:number){
Swal.fire({
  title: '<i  style="color:#d6c07f;"></i> ¿Estás seguro que quieres dar de baja el plantel?',
  html: '<p style="text-align:center; color:#333; margin:10px 0;">Esta acción no se puede deshacer.</p>',
  icon: 'question',
  iconColor: '#d6c07f',
  showCancelButton: true,
  confirmButtonColor: '#B24B44',
  cancelButtonColor: '#606062',
  confirmButtonText: 'Sí, dar de baja',
  cancelButtonText: 'Cancelar',
  background: '#ffffff',
  customClass: {
    popup: 'animated-popup'
  },
  backdrop: 'rgba(0,0,0,0.3)'
}).then((result) => {
  
    if (result.isConfirmed) {
      this.plantelesService.deletePlantel(id, this.mailusu).subscribe(
        res=>{

          if(res=="TOKEN-EXPIRADO"){
            this.msj.tokenExpiradoCerrarSesion();  
            return; 
        }

          Swal.fire(
            '¡El plantel se dio de baja!',
            '',
            'success',
          )
          location.reload();

        },
        err=>console.log(err)
      );
    }
  })

}

permisos(){
  if(this.cargo=="Administrativo"){    
   this.permisosplantel=false;
         this.permisosdg=true;

  } else{

  } if(this.cargo=="Dirección General"){    
   this.permisosplantel=true;
      this.permisosdg=false;

  }
}

permisosdirector(){
  if(this.plantel!= "0"){
    this.cargodirector=false;
  }
  

}


guardarPlantel(){
  // tslint:disable-next-line: triple-equals

    this.plantelesService.createPlantel(this.planteless, this.mailusu)
    .subscribe(
      res => {

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();   
          return;
      }

        Swal.fire(
          '¡El Plantel se Ha Registrado Exitosamente!',
          '',
          'success',
        )
        location.reload()
      },
      err => console.error(err)
    );
  

}
  
  cancelar(){
  location.reload();

}


}
